<template>
  <teleport to="body">
    <div class="modal" :class="{ active: true }">
      <div class="modal-header">
        <div v-if="type === 'pdf'" class="document-navigation">
          <button
            aria-label="Previous page"
            class="document-navigation-button"
            @click="changePage('prev')"
          >
            ⇦
          </button>
          {{ currentPage }} / {{ numPages }}
          <button
            aria-label="Next page"
            class="document-navigation-button"
            @click="changePage('next')"
          >
            ⇨
          </button>
        </div>
        <button aria-label="Close" class="close-button" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <VuePdfEmbed
          v-if="src && type === 'pdf'"
          :source="src"
          :page="currentPage"
          @loaded="updateNumberOfPages"
        />
        <div v-else class="preview-container">
          <img
            v-if="src"
            class="image-container"
            :src="src"
            :alt="$t('general__text__preview-not-available-for-file-type')"
          />
          <PulseLoader v-else :loading="!src" class="spinner" color="#1d234f" />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VuePdfEmbed from 'vue-pdf-embed'

export default {
  name: 'FilePreview',
  components: {
    VuePdfEmbed,
    PulseLoader
  },
  props: {
    src: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  emits: ['close'],
  data() {
    return {
      currentPage: 1,
      numPages: null
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    changePage(change) {
      if (change === 'next') {
        if (this.currentPage < this.numPages) this.currentPage += 1
        return
      }
      if (this.currentPage !== 1) this.currentPage -= 1
    },
    updateNumberOfPages(pdf) {
      this.numPages = pdf.numPages
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/design-system/design-tokens/mixins.scss';

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: 200ms ease-in-out;
  z-index: 1000;
  background: #ffffff;
  border-radius: 2px;
  width: 40%;
  height: 90%;
  overflow-y: auto;
  padding: 10px;
}
.modal.active {
  transform: translate(-50%, -50%) scale(1);
}
.modal-header {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 10%;
}
.close-button {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  font-size: 40px;
  color: #000;
}
.document-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.document-navigation-button {
  font-size: 15px;
  cursor: pointer;
}
.modal-body {
  height: 90%;
  overflow-y: auto;
  @include mixins.scrollbar-vertical;
}
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.image-container {
  max-width: 90%;
  max-height: 90%;
}
</style>
